'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UITag from 'UIComponents/tag/UITag';
import FormattedMessage from 'I18n/components/FormattedMessage';
export const getDocAnchorId = (method, path) => `anchor-${method}-${path}`;
export const renderAuthTypes = securityTypes => {
  if (!securityTypes.length) {
    return /*#__PURE__*/_jsx(UITag, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "developer-docs-shared-components.authTypes.NO_AUTH"
      })
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: securityTypes.map(securityType => /*#__PURE__*/_jsx(UITag, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `developer-docs-shared-components.authTypes.${securityType}`
      })
    }, securityType))
  });
};